import { useUserStore } from '@/stores';

export function useCompactMode() {
  const compactMode = useUserStore(state =>
    state.userSettings.compactMode === true
  );
  const updateUserSettings = useUserStore(state => state.updateUserSettings);

  const setCompactMode = (value: boolean) => {
    updateUserSettings('compactMode', value);
  };

  return { compactMode, setCompactMode };
}
